import { PureComponent } from 'react';
import { AnalyticsEvents } from '@sda/interfaces/queue/analytics';

export class Facebook extends PureComponent {
  /**
   * Track standard facebook pixel event
   * @param {string} event
   * @param {JSON} data
   */
  static track = (event, data) => {
    if (window && window.fbq) {
      window.fbq('track', event, data);
    }
  };

  /**
   * Track custom facebook pixel event
   * @param {string} event
   * @param {JSON} data
   */
  static trackCustom = (event, data) => {
    if (window && window.fbq) {
      window.fbq('trackCustom', event, data);
    }
  };

  /**
   * Grant or revoke consent https://developers.facebook.com/docs/facebook-pixel/implementation/gdpr
   * @param {*} acceptsCookies
   */
  static setConsent = (acceptsCookies) => {
    const permissions = acceptsCookies ? 'grant' : 'revoke';

    if (window && window.fbq) {
      window.fbq('consent', permissions);
    }
  };

  /**
   * Push event and event data to facebook pixel
   * @param array data
   */
  static push = (event, data) => {
    if (window && window.fbq) {
      switch (event) {
        case AnalyticsEvents.VIEWED_PAGE:
          Facebook.track('PageView', data); // data props not required
          break;

        case AnalyticsEvents.PURCHASED_TICKET:
          Facebook.track('Purchased');
          break;

        default:
          Facebook.trackCustom(event);
          break;
      }
    }
  };

  componentDidMount() {
    const { acceptsCookies } = this.props;

    Facebook.setConsent(acceptsCookies);
  }

  componentDidUpdate(prevProps) {
    const { acceptsCookies } = this.props;

    if (prevProps.acceptsCookies !== acceptsCookies) {
      Facebook.setConsent(acceptsCookies);
    }
  }

  render() {
    return null;
  }
}
